module.exports = __webpack_public_path__ + "../resources/img/ic_dashboard_refresh.38f3c26a.svg";